"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * CMC Markets Developer Portal
 * ### Invoke API using this Dev Portal    * Open `API Servers` and select the API Server to be used    * Open `Authentication`, select `Request Body` instead of *Authorization Header* and `Get Token` to fetch a JWT token    * Invoke the function  ### Generate Client Code  ```docker run --rm -v ${PWD}:/local openapitools/openapi-generator-cli generate -i https://api-signup.invest.cmcmarkets.com.au/developer/swagger.json -g typescript-fetch -o /local/ts```
 *
 * The version of the OpenAPI document: 1.4.82
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Configuration = void 0;
var Configuration = /** @class */ (function () {
    function Configuration(param) {
        if (param === void 0) { param = {}; }
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
        this.baseOptions = param.baseOptions;
        this.formDataCtor = param.formDataCtor;
    }
    /**
     * Check if the given MIME is a JSON MIME.
     * JSON MIME examples:
     *   application/json
     *   application/json; charset=UTF8
     *   APPLICATION/JSON
     *   application/vnd.company+json
     * @param mime - MIME (Multipurpose Internet Mail Extensions)
     * @return True if the given MIME is JSON, false otherwise.
     */
    Configuration.prototype.isJsonMime = function (mime) {
        var jsonMime = new RegExp('^(application\/json|[^;/ \t]+\/[^;/ \t]+[+]json)[ \t]*(;.*)?$', 'i');
        return mime !== null && (jsonMime.test(mime) || mime.toLowerCase() === 'application/json-patch+json');
    };
    return Configuration;
}());
exports.Configuration = Configuration;
